import React, { useEffect, useState } from "react";

const Footer = () => {
    const scrollTop = () => {
        window.scrollTo(0, 0);
    };

    const [btnTopClass, setBtnTopClass] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", e => {
            let posY = window.scrollY;
            if (posY > 100) {
                setBtnTopClass(true);
            } else {
                setBtnTopClass(false);
            }
        });
    }, []);

    return (
        <footer>
            <div className="inner">
                <button type="button" className={btnTopClass ? "btn_top scroll" : "btn_top"} onClick={scrollTop}>
                    TOP
                </button>
                <div className="left">
                    <address>
                        <p className="name">(주)케이티엠오에스북부</p>
                        <p>
                            <span>
                                <b>CEO</b> 김철기
                            </span>
                            <span>
                                <b>사업자등록번호</b> 215-86-40364
                            </span>
                            <br />
                            <span>서울시 강남구 광평로 47길 28. KT수서빌딩 1층</span>
                            <span>
                                <b>TEL</b> 02-703-5751
                            </span>
                            <span>
                                <b>FAX</b> 02-703-5754
                            </span>
                        </p>
                    </address>
                    <ul className="ft_menu">
                        {/* <li className="underline">
                            <a href="#">개인정보처리방침</a>
                        </li>
                        <li>
                            <a href="#">이메일무단수집거부</a>
                        </li>
                        <li>
                            <a href="#">ADMIN</a>
                        </li> */}
                    </ul>
                </div>

                <div className="rights">
                    <h2 className="logo">kt Mos 북부</h2>
                    <p className="copyright">Copyrightⓒ 2022 kt MOS 북부.All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
